import authPartner from '../../fields/other/authPartner';

export const MUTATION_RECREATE_AUTH_PARTNER_KEY_PAIR = /* GraphQL */ `
	mutation($id: String!) {
		recreateAuthPartnerKeyPair(id: $id) {
			secretKey
			authPartner {
				${authPartner}
			}
		}
	}
`;
